import { formatBRL } from '../../../../utils/currencyUtils';
import { summarizeCharges } from '../services/chargeSummary';
import PageTotalsBar from './PageTotalsBar';

const ChargeTotalsBar: React.FC<{ rows: any[] }> = ({ rows }) => {
    const summary = summarizeCharges(rows);
    return (
        <PageTotalsBar
            counts={[
                { label: 'Operações', value: summary.operations.count },
                { label: 'Cedentes', value: summary.issuers.count },
                { label: 'Devedores', value: summary.payers.count },
            ]}
            natures={summary.natures}
            amounts={[
                { label: 'Valor', value: formatBRL(summary.amount), emphasis: true },
                { label: 'Pago', value: formatBRL(summary.paidAmount) },
                { label: 'Delta', value: formatBRL(summary.remainingAmount) },
            ]}
        />
    );
};

export default ChargeTotalsBar;
